import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { DatePickerField, BaasicButton, BaasicConfirmModal } from 'core/components';
function NikoPatientStatusModalTemplate({ nikoPatientStatusModalStore, t }) {
    const {
        form,
        modalParams,
        status,
        isDateVisible,
        inactiveDateConfirmationModal,
        disabled,
        additionalMessage
    } = nikoPatientStatusModalStore;

    return (
        <section>
            <KeyDownListener onConfirm={() => { form.submit() }} />
            <div className="modal__header">
                <h3 className='modal__header__title'>{t('NIKO_PATIENT.NIKO_PATIENT_STATUS_MODAL.STATUS_CHANGE_TITLE')}</h3>
            </div>
            <div className="modal__body">
                <p className='type--base u-padd--right--med u-mar--top--med'>
                    {t('NIKO_PATIENT.NIKO_PATIENT_STATUS_MODAL.STATUS_CHANGE_MESSAGE')}<span className="type--wgt--bold">{status}</span>?
                </p>
                {additionalMessage &&
                    <p className='type--base u-padd--right--med'>
                        {additionalMessage}
                    </p>
                }
                {isDateVisible &&
                    <div
                        className="form__group u-mar--top--med"
                        ref={(el) => {
                            if (el) {
                                const input = el.querySelector('input');
                                if (input) {
                                    input.focus();
                                    input.select();
                                }
                            }
                        }}
                    >
                        <DatePickerField field={form.$('inactiveDate')} disabled={disabled || form.submitting || form.validating} />
                    </div>
                }
            </div>
            <div className='modal__footer is-right'>
                <BaasicButton
                    className='btn btn--med btn--light'
                    label={t('EDIT_FORM_LAYOUT.CANCEL')}
                    onClick={() => modalParams.close()}
                    disabled={disabled || form.submitting || form.validating}
                />
                <BaasicButton
                    type='submit'
                    className="btn btn--med btn--primary"
                    onClick={form.onSubmit}
                    disabled={disabled || form.submitting || form.validating}
                    rotate
                    icon={
                        disabled || form.submitting || form.validating
                            ? "u-icon u-icon--sml u-icon--sync u-rotate--login u-mar--right--tny"
                            : 'u-display--none'
                    }
                    label={t('EDIT_FORM_LAYOUT.CONFIRM')}
                    authorized={true}
                />
            </div>
            <BaasicConfirmModal modalParams={inactiveDateConfirmationModal} />
        </section>
    )
}

const KeyDownListener = ({ onConfirm }) => {
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "Enter") {
                onConfirm();
            }
        };

        window.addEventListener("keydown", handleKeyDown);
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, []);
    return null;
}

KeyDownListener.propTypes = {};

NikoPatientStatusModalTemplate.propTypes = {
    nikoPatientStatusModalStore: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(NikoPatientStatusModalTemplate);
